import React, { useState, useContext, useEffect } from "react"
import { AppContext } from "./index"
import AltaIncidente from "./AltaIncidente"

export default function Incidente({ i }) {
    let { firebase } = useContext(AppContext)

    const [incidente, setIncidente] = useState(null)
    useEffect(() => { setIncidente(firebase.incidente(i)) }, [i, firebase])

    return (
        <div style={Smarco}>
            {incidente && <AltaIncidente incidente={incidente} />}
        </div>
    )
}

const Smarco = {
    margin: "25px",
};
